'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _click_or_escape_outside = require('./click_or_escape_outside.js');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _date_dropdown_component = require('./global_components/date_dropdown_component.js');

var _date_dropdown_component2 = _interopRequireDefault(_date_dropdown_component);

var _performance_chart = require('./charts/performance_chart.js');

var _performance_chart2 = _interopRequireDefault(_performance_chart);

var _date_range_dropdown = require('./global_components/date_range_dropdown');

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _ramda = require('ramda');

var _legendCircle = require('./charts/legendCircle');

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _date_formatter3 = require('common-utilities/src/date_formatter');

var _dropdown_component = require('./global_components/dropdown_component');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _chart_utility = require('../../../packages/common-utilities/src/chart_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _constants = require('../../../packages/common-utilities/src/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var yearMonthFormat = "YYYY-MM";
var includeBetweenDates = "[]";
var TAG = _constants2.default.getFdTagConstants();
var getDateFromObject = function getDateFromObject(data) {
  var pathToDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "date";
  return (0, _ramda.path)([pathToDate], data);
};
var subtractYears = function subtractYears(date, numberOfYears) {
  return (0, _moment2.default)(date).subtract(numberOfYears, "years").format(_date_formatter2.default.edpiDateFormat);
};
var setTooltipWrapper = function setTooltipWrapper(text) {
  return _react2.default.createElement(
    'span',
    { 'data-testid': 'tooltip-error',
      className: 'caption font-light font-extreme-red' },
    text
  );
};

var PerformanceChartParent = function (_React$Component) {
  _inherits(PerformanceChartParent, _React$Component);

  function PerformanceChartParent(props) {
    _classCallCheck(this, PerformanceChartParent);

    var _this = _possibleConstructorReturn(this, (PerformanceChartParent.__proto__ || Object.getPrototypeOf(PerformanceChartParent)).call(this, props));

    _this.injectComponent = (0, _reactIntl.injectIntl)(_performance_chart2.default);
    _this.dateRangeItems = _this.dateRangeItems.bind(_this);
    _this.getErrorMessageForDate = _this.getErrorMessageForDate.bind(_this);
    _this.getFilteredDataByDateRange = _this.getFilteredDataByDateRange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onBlurCustomDate = _this.onBlurCustomDate.bind(_this);
    _this.onChangeCustomDateFrom = _this.onChangeCustomDateFrom.bind(_this);
    _this.onChangeCustomDateTo = _this.onChangeCustomDateTo.bind(_this);
    _this.onCustomDateFilterKeyPress = _this.onCustomDateFilterKeyPress.bind(_this);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    _this.renderDateDropdown = _this.renderDateDropdown.bind(_this);
    _this.resetErrorState = _this.resetErrorState.bind(_this);
    _this.resetErrorStateBP1 = _this.resetErrorStateBP1.bind(_this);
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.renderPopIcon = _this.renderPopIcon.bind(_this);
    _this.renderToolTipErrorMessage = _this.renderToolTipErrorMessage.bind(_this);
    _this.setCustomDateRangeDropdown = _this.setCustomDateRangeDropdown.bind(_this);
    _this.setCustomFromAndToDates = _this.setCustomFromAndToDates.bind(_this);
    _this.setDateFilter = _this.setDateFilter.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.updateInitialAmount = _this.updateInitialAmount.bind(_this);
    _this.uiDateFormat = _this.uiDateFormat.bind(_this);
    _this.updateFromAndToDateLabel = _this.updateFromAndToDateLabel.bind(_this);
    _this.renderCustomDateFilters = _this.renderCustomDateFilters.bind(_this);
    _this.addYearMapsToDateRangeArray = _this.addYearMapsToDateRangeArray.bind(_this);
    _this.onClickCustomDate = _this.onClickCustomDate.bind(_this);
    _this.trackChartDownload = _this.trackChartDownload.bind(_this);
    _this.onKeyPressRegularSavingAmount = _this.onKeyPressRegularSavingAmount.bind(_this);
    _this.onRegularSavingAmtBlur = _this.onRegularSavingAmtBlur.bind(_this);
    _this.selectedRegularSavingAmountFrequency = _this.selectedRegularSavingAmountFrequency.bind(_this);
    _this.updateRegularSavingAmount = _this.updateRegularSavingAmount.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.handlePopIconClick = _this.handlePopIconClick.bind(_this);

    _this.amountFilterRef = _react2.default.createRef();
    _this.fromMonthDropdownRef = _react2.default.createRef();
    _this.fromYearDropdownRef = _react2.default.createRef();
    _this.toMonthDropdownRef = _react2.default.createRef();
    _this.toYearDropdownRef = _react2.default.createRef();
    _this.regularSavingAmountFilterRef = _react2.default.createRef();

    _this.minDate = _date_formatter2.default.getDateInSpecificFormat(getDateFromObject(_this.props.performanceDataForChart[0]), yearMonthFormat);
    _this.maxDate = _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(_this.props.performanceDataForChart)), yearMonthFormat);
    _this.minDateForToDate = (0, _moment2.default)(_this.minDate).add(1, 'years').format(yearMonthFormat);
    _this.maxDateForFromDate = (0, _moment2.default)(_this.maxDate).subtract(1, 'years').format(yearMonthFormat);

    _this.minDateInEdpiFormat = getDateFromObject(_this.props.performanceDataForChart[0]);
    _this.maxDateInEdpiFormat = getDateFromObject((0, _ramda.last)(_this.props.performanceDataForChart));

    _this['dropdown-toggle-from'] = { 'value': '' };
    _this['dropdown-toggle-to'] = { 'value': '' };
    _this['dropdown-label-dateRange'] = { 'text': '' };

    var selectedDateOption = "Since Inception",
        selectedDateOptionTranslateKey = "since-inception";
    var performanceChartData = _collection_utility.CollectionUtility.clone(_this.props.performanceDataForChart);
    var performanceFromDate = getDateFromObject(_this.props.performanceDataForChart[0]);
    var selectedDateOptionValue = '0';

    if (_this.shouldDisplaySinceDataAvailable()) {
      selectedDateOption = "Since Data Available";
      selectedDateOptionTranslateKey = "since-data-available";
    }

    if (!(0, _ramda.isNil)((_this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((_this.props.visibleData || {}).visibleDataPoints, 'HYPO_CHART_DEFAULT_FIVE_YEAR_OPTION')) {
      selectedDateOption = "Last 5 years";
      selectedDateOptionTranslateKey = "dropdown-last-5-years";
      performanceChartData = _this.getFilteredData(59);
      selectedDateOptionValue = '59';
      performanceFromDate = _date_formatter2.default.getDateInSpecificFormat(subtractYears(_moment2.default.utc(getDateFromObject((0, _ramda.last)(_this.props.performanceDataForChart))), 5), "YYYY-MM-DD");
    }

    _this.state = {
      initialAmount: _this.getDefaultInitialAmount(),
      selectedDateOption: selectedDateOption,
      selectedDateOptionTranslateKey: selectedDateOptionTranslateKey,
      selectedDateOptionValue: selectedDateOptionValue,
      performanceChartData: performanceChartData,
      fromDateValue: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject(_this.props.performanceDataForChart[0]), yearMonthFormat),
      toDateValue: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(_this.props.performanceDataForChart)), yearMonthFormat),
      count: 5,
      error: "moderate",
      errorId: null,
      performanceFromDate: performanceFromDate,
      performanceToDate: getDateFromObject((0, _ramda.last)(_this.props.performanceDataForChart)),
      regularSavingAmount: null,
      regularSavingAmountFrequency: null,
      regularSavingAmountFrequencyTranslatedKey: null,
      inceptionMonthROR: performanceChartData[0].cumulativeNoLoadPercentage
    };

    return _this;
  }

  _createClass(PerformanceChartParent, [{
    key: 'componentDidMount',
    value: function componentDidMount(dataPerformanceDataForChart) {
      var performanceData = dataPerformanceDataForChart || this.props.performanceDataForChart.length;
      if (!(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_DROPDOWN_WITH_SHARECLASS_LAUNCH_DATE')) {
        var years = (0, _moment2.default)().diff(this.props.shareClassInceptionDate, 'years');
        if (years <= 1) {
          this.setState({ count: 2 });
        } else if (years <= 3) {
          this.setState({ count: 3 });
        } else if (years <= 5) {
          this.setState({ count: 4 });
        } else if (years <= 10) {
          this.setState({ count: 5 });
        } else if (years <= 15) {
          if ((0, _moment2.default)().diff(getDateFromObject(this.props.performanceDataForChart[0]), 'years') >= 15) {
            this.setState({ count: 6 });
          } else {
            this.setState({ count: this.getDropDownSliceIndexByPerformanceData(this.props.performanceDataForChart[0]) });
          }
        } else if ((0, _moment2.default)().diff(getDateFromObject(this.props.performanceDataForChart[0]), 'years') >= 20) {
          this.setState({ count: 7 });
        } else {
          this.setState({ count: this.getDropDownSliceIndexByPerformanceData(this.props.performanceDataForChart[0]) });
        }
      } else {
        this.getDropDownRowCountsByPerformanceDataCount(performanceData);
      }
    }
  }, {
    key: 'uiDateFormat',
    value: function uiDateFormat(format) {
      return format === "european" ? "MM.YYYY" : "MM/YYYY";
    }
  }, {
    key: 'isFundExactlyOneYearOld',
    value: function isFundExactlyOneYearOld() {
      if ((0, _ramda.lte)(_collection_utility.CollectionUtility.size(this.props.performanceDataForChart), 13) && !(0, _functional_utility.isNilOrEmpty)(this.props.visibleData.formattingRules) && _collection_utility.CollectionUtility.includes(this.props.visibleData.formattingRules, 'PERFORMANCE_CHART_EXACTLY_ONE_YEAR')) {
        return true;
      }
      return false;
    }
  }, {
    key: 'getDropDownSliceIndexByPerformanceData',
    value: function getDropDownSliceIndexByPerformanceData(performanceData) {
      var years = (0, _moment2.default)().diff(performanceData.date, 'years');
      if (years <= 1) {
        return 2;
      } else if (years <= 3) {
        return 3;
      } else if (years <= 5) {
        return 4;
      } else if (years <= 10) {
        return 5;
      } else if (years <= 15) {
        return 6;
      } else {
        return 7;
      }
    }
  }, {
    key: 'getDropDownRowCountsByPerformanceDataCount',
    value: function getDropDownRowCountsByPerformanceDataCount(performanceData) {
      if (performanceData > 240) {
        this.setState({ count: 7 });
      } else if (performanceData > 180) {
        this.setState({ count: 6 });
      } else if (performanceData > 120) {
        this.setState({ count: 5 });
      } else if (performanceData > 60) {
        this.setState({ count: 4 });
      } else if (performanceData > 36) {
        this.setState({ count: 3 });
      } else if (performanceData > 12) {
        this.setState({ count: 2 });
      }
    }
  }, {
    key: 'shouldDisplaySinceDataAvailable',
    value: function shouldDisplaySinceDataAvailable() {
      var initialPerformanceData = this.earliestPerformanceChartData().date;
      return !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_DROPDOWN_WITH_SHARECLASS_LAUNCH_DATE') && (0, _moment2.default)(this.props.shareClassInceptionDate).isBefore(initialPerformanceData);
    }
  }, {
    key: 'isInceptionMonth',
    value: function isInceptionMonth(firstDate) {
      var initialPerformanceData = this.earliestPerformanceChartData().date;
      return initialPerformanceData === firstDate && !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_INCEPTION_MONTH_WITH_ROR');
    }
  }, {
    key: 'doesFormattingRulesContains',
    value: function doesFormattingRulesContains(visibleDataPointName) {
      return (0, _ramda.includes)(visibleDataPointName, (0, _functional_utility.pathOrEmptyArray)(["visibleData", "formattingRules"], this.props));
    }
  }, {
    key: 'getDefaultInitialAmount',
    value: function getDefaultInitialAmount() {
      if (this.doesFormattingRulesContains("PERFORMANCE_CHART_INITIAL_AMOUNT_10K")) {
        return 10000;
      } else if (!(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHARECLASS_NAV')) {
        return 100;
      } else if (this.props.fundTypeCode === "FT_LIQUIDITY_FUND" && !(0, _ramda.isNil)((this.props.minimumInvestments || {}).regularInvestments)) {
        return this.props.minimumInvestments.regularInvestments;
      }
      return 100000;
    }
  }, {
    key: 'getFormattedInitialAmountBasedOnCategoryCode',
    value: function getFormattedInitialAmountBasedOnCategoryCode() {
      return this.getFormattedValue(this.getDefaultInitialAmount());
    }
  }, {
    key: 'setDateFilter',
    value: function setDateFilter(event) {
      var _this2 = this;

      var filteredData = void 0;
      var dateOption = 0;
      var toDate = '';
      var fromDate = '';

      var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;

      var shouldShowPerAdvTitle = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_PER_ADV_TITLE');
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": shouldShowPerAdvTitle ? "performance chart" : "growth of hypothetical investment chart",
        "eventLabel": target.getAttribute("data-display-value")
      });

      if (target.getAttribute('data-option-value') === 'custom') {
        this['dropdown-label-dateRange'].text = 'Custom Date Range';

        toDate = getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart));
        if (this.state.selectedDateOptionValue === '0') {
          fromDate = getDateFromObject(this.props.performanceDataForChart[0]);
        } else {
          fromDate = _moment2.default.utc(toDate).subtract(Number(this.state.selectedDateOptionValue), 'months');
        }
        fromDate = _date_formatter2.default.getDateInSpecificFormat(fromDate, yearMonthFormat);
        toDate = _date_formatter2.default.getDateInSpecificFormat(toDate, yearMonthFormat);
        this.setState({
          selectedDateOption: target.getAttribute('data-display-value'),
          selectedDateOptionTranslateKey: target.getAttribute('data-translation-key'),
          toDateValue: toDate,
          fromDateValue: fromDate,
          selectedDateOptionValue: 'custom'
        });
      } else {
        this['dropdown-label-dateRange'].text = target.getAttribute('data-display-value');
        dateOption = Number(target.getAttribute('data-option-value'));

        toDate = getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart));
        var numberOfYears = (0, _ramda.cond)([[(0, _ramda.equals)(0), (0, _ramda.always)(0)], [(0, _ramda.equals)(11), (0, _ramda.always)(1)], [(0, _ramda.equals)(35), (0, _ramda.always)(3)], [(0, _ramda.equals)(59), (0, _ramda.always)(5)], [(0, _ramda.equals)(119), (0, _ramda.always)(10)], [(0, _ramda.equals)(179), (0, _ramda.always)(15)], [(0, _ramda.equals)(239), (0, _ramda.always)(20)]])(dateOption);
        var performanceFromDate = numberOfYears === 0 ? getDateFromObject(this.props.performanceDataForChart[0]) : subtractYears(getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart)), numberOfYears);
        if (dateOption === 0) {
          fromDate = getDateFromObject(this.props.performanceDataForChart[0]);
          filteredData = _collection_utility.CollectionUtility.clone(this.props.performanceDataForChart);
        } else {
          fromDate = _moment2.default.utc(toDate).subtract(dateOption, 'months');
          filteredData = this.getFilteredData(dateOption);
        }
        fromDate = _date_formatter2.default.getDateInSpecificFormat(fromDate, yearMonthFormat);
        toDate = _date_formatter2.default.getDateInSpecificFormat(toDate, yearMonthFormat);

        this.setState({
          selectedDateOptionValue: dateOption.toString(),
          selectedDateOption: target.getAttribute('data-display-value'),
          selectedDateOptionTranslateKey: target.getAttribute('data-translation-key'),
          performanceChartData: filteredData,
          toDateValue: toDate,
          fromDateValue: fromDate,
          performanceFromDate: performanceFromDate,
          performanceToDate: getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart)),
          error: 'moderate',
          errorId: null
        }, function () {
          _this2.props.tooltip.closeTooltip();
        });

        this['dropdown-toggle-from'].value = _date_formatter2.default.getDateInSpecificFormat(performanceFromDate, this.uiDateFormat(this.props.numberFormat));
        this['dropdown-toggle-to'].value = _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart)), this.uiDateFormat(this.props.numberFormat));
      }

      var fromMonth = _date_formatter3.MONTHS[parseInt(fromDate.split('-')[1], 10) - 1];
      var toMonth = _date_formatter3.MONTHS[parseInt(toDate.split('-')[1], 10) - 1];
      this.updateMonthYearDropDownListSelectedValue(this.fromYearDropdownRef, "from-year", parseInt(fromDate.split("-")[0]));
      this.updateMonthYearDropDownListSelectedValue(this.fromMonthDropdownRef, "from-month", _string_utility2.default.getLocalizedString(this.props.intl, fromMonth.value, fromMonth.translationKey));
      this.updateMonthYearDropDownListSelectedValue(this.toYearDropdownRef, "to-year", parseInt(toDate.split("-")[0]));
      this.updateMonthYearDropDownListSelectedValue(this.toMonthDropdownRef, "to-month", _string_utility2.default.getLocalizedString(this.props.intl, toMonth.value, toMonth.translationKey));
    }
  }, {
    key: 'getFilteredData',
    value: function getFilteredData(dateOption) {
      var latestMonthEnd = getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart));
      var filteredDate = _moment2.default.utc(latestMonthEnd).subtract(Number(dateOption), 'months');
      return _collection_utility.CollectionUtility.filter(this.props.performanceDataForChart, function (performance) {
        return performance.epochDate >= filteredDate;
      });
    }
  }, {
    key: 'getFilteredDataByDateRange',
    value: function getFilteredDataByDateRange(fromDate, toDate) {
      var normalizedFromDate = _moment2.default.utc((0, _moment2.default)(fromDate).endOf('month'));
      var normalizedToDate = _moment2.default.utc((0, _moment2.default)(toDate).endOf('month'));

      return _collection_utility.CollectionUtility.filter(this.props.performanceDataForChart, function (performance) {
        return (0, _moment2.default)(performance.epochDate).isBetween(normalizedFromDate, normalizedToDate);
      });
    }
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      if (e.key === 'Enter') {
        var newAmount = this.amountFilterRef.current.value;
        var numericAmount = void 0;
        numericAmount = newAmount.match(/\d/g);
        if (!(0, _ramda.isNil)(numericAmount)) {
          numericAmount = Number(numericAmount.join(""));
        }
        if (numericAmount > 10000.00 || numericAmount < 100000000000.00) {
          this.setState({
            error: "moderate"
          });
          this.props.tooltip.closeTooltip();
        }
        if (numericAmount !== this.state.initialAmount) {
          this.setNewAmount(numericAmount);
        }
      }
    }
  }, {
    key: 'onKeyPressRegularSavingAmount',
    value: function onKeyPressRegularSavingAmount(e) {
      if (e.key === 'Enter') {
        var newAmount = this.regularSavingAmountFilterRef.current.value;
        var numericAmount = void 0;
        numericAmount = newAmount.match(/\d/g);
        if (!(0, _ramda.isNil)(numericAmount)) {
          numericAmount = Number(numericAmount.join(""));
        }
        if (numericAmount > 50.00 || numericAmount < 10000.00) {
          this.setState({
            error: "moderate"
          });
          this.props.tooltip.closeTooltip();
        }
        if (numericAmount !== this.state.initialAmount) {
          this.setRegularSavingAmount(numericAmount);
        }
      }
    }
  }, {
    key: 'onCustomDateFilterKeyPress',
    value: function onCustomDateFilterKeyPress(e) {
      if (e.key === "Enter") {
        this.setCustomFromAndToDates(e);
        this.resetErrorState();
      }
    }
  }, {
    key: 'closeErrorTooltip',
    value: function closeErrorTooltip() {
      this.props.tooltip.closeTooltip();
    }
  }, {
    key: 'getErrorMessageForDate',
    value: function getErrorMessageForDate(uiDate, edpiFormattedDate, isFrom) {
      var _state = this.state,
          performanceFromDate = _state.performanceFromDate,
          performanceToDate = _state.performanceToDate;

      var errorMessage = "";

      if (!_date_formatter2.default.validateDateMMYYYY(uiDate)) {
        errorMessage = _string_utility2.default.renderFormattedLabel("Please enter valid month year combination in MM/YYYY format.", "pdp-performance-chart-error-message-invalid-date");
        return errorMessage;
      }

      var dateRangeGreaterThanAYear = isFrom ? _date_formatter2.default.dateRangeIsGreaterThanAYear(edpiFormattedDate, performanceToDate) : _date_formatter2.default.dateRangeIsGreaterThanAYear(performanceFromDate, edpiFormattedDate);
      var isDataAvailableMoreThanAYear = _date_formatter2.default.dateRangeIsGreaterThanAYear(this.minDate, this.maxDate);
      var isFromBeforeToDate = isFrom ? (0, _moment2.default)(edpiFormattedDate).isAfter(performanceToDate) : (0, _moment2.default)(edpiFormattedDate).isBefore(performanceFromDate);

      if (!(0, _ramda.isNil)(this.props.minStartDate) && this.selectedDateIsBeforeMinDate(edpiFormattedDate) && !(0, _fund_utility.isSGNonLiq)(this.props.country, this.props.role)) {
        errorMessage = _string_utility2.default.renderFormattedLabel("Performance data available since December 31 2002. Please enter another date.", "pdp-performance-chart-error-message-prior-to-min-Date");
      } else if (this.selectedDateIsBeforeMinAvailableDate(edpiFormattedDate)) {
        errorMessage = _string_utility2.default.renderFormattedLabel("The date entered predates product inception. Please enter another date.", "pdp-performance-chart-error-message-prior-to-inception-date");
      } else if (this.selectedDateIsAfterMaxDate(edpiFormattedDate)) {
        errorMessage = _string_utility2.default.renderFormattedLabel("This is past the available range. Please enter another date.", "pdp-performance-chart-error-message-after-max-date");
      } else if (isFromBeforeToDate) {
        errorMessage = _string_utility2.default.renderFormattedLabel("From Date has to be less than To Date and at least 1 year.", "pdp-performance-chart-error-message-invalid-from-date");
      } else if (!dateRangeGreaterThanAYear && isDataAvailableMoreThanAYear) {
        errorMessage = _string_utility2.default.renderFormattedLabel("The date range must be at least 1 year.", "pdp-performance-chart-error-message-invalid-date-range");
      }

      return errorMessage;
    }
  }, {
    key: 'setCustomFromAndToDates',
    value: function setCustomFromAndToDates(e, dropdownId) {
      this.trackDateChange();
      var _state2 = this.state,
          performanceToDate = _state2.performanceToDate,
          performanceFromDate = _state2.performanceFromDate;

      var overrideTooltipProps = { toolTipWidth: "254px", toolTipContentWidth: "100%" };
      var targetId = (0, _ramda.pathOr)(false, ["target", "id"], e);

      if ((0, _ramda.or)(targetId === "dropdown-toggle-from", dropdownId === "from-dropdown")) {
        var fromDateUIValue = this["dropdown-toggle-from"].value;
        var selectedFromDate = this.getLastDateOfMonthOfData(fromDateUIValue);
        var errorMessage = this.getErrorMessageForDate(fromDateUIValue, selectedFromDate, true);
        var validFromDateInput = (0, _ramda.isEmpty)(errorMessage);

        if (validFromDateInput) {
          var filteredList = this.getFilteredDataByDateRange(selectedFromDate, performanceToDate);

          if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHARECLASS_NAV')) {
            var initialAmount = this.getDefaultInitialAmount();

            var list = this.props.performanceDataForChart.filter(function (e) {
              return !filteredList.includes(e);
            });

            (0, _ramda.map)(function (data) {
              initialAmount = Math.round(initialAmount * (1 + data.cumulativeNoLoadPercentage));
            }, list);

            initialAmount = Math.round(initialAmount * (1 + filteredList[0].cumulativeNoLoadPercentage));

            this.setState({ initialAmount: initialAmount });
          }

          this.setState({
            performanceFromDate: selectedFromDate,
            performanceChartData: filteredList
          });

          this["dropdown-toggle-from"].value = _date_formatter2.default.getDateInSpecificFormat(selectedFromDate, this.uiDateFormat(this.props.numberFormat));
        } else {
          this.renderToolTipErrorMessage("dropdown-toggle-from", setTooltipWrapper(errorMessage), overrideTooltipProps);
        }
      } else if ((0, _ramda.or)(targetId === "dropdown-toggle-to", dropdownId === "to-dropdown")) {
        var toDateUIValue = this["dropdown-toggle-to"].value;
        var selectedToDate = this.getLastDateOfMonthOfData(toDateUIValue);
        var _errorMessage = this.getErrorMessageForDate(toDateUIValue, selectedToDate, false);
        var validToDateInput = (0, _ramda.isEmpty)(_errorMessage);

        if (validToDateInput) {
          this.setState({
            performanceToDate: selectedToDate,
            performanceChartData: this.getFilteredDataByDateRange(performanceFromDate, selectedToDate)
          });
          this["dropdown-toggle-to"].value = _date_formatter2.default.getDateInSpecificFormat(selectedToDate, this.uiDateFormat(this.props.numberFormat));
        } else {
          this.renderToolTipErrorMessage("dropdown-toggle-to", setTooltipWrapper(_errorMessage), overrideTooltipProps);
        }
      }
    }
  }, {
    key: 'trackDateChange',
    value: function trackDateChange() {
      var shouldShowPerAdvTitle = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_PER_ADV_TITLE');
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'pdp',
        "eventAction": shouldShowPerAdvTitle ? 'performance chart' : 'growth of hypothetical investment chart',
        'eventLabel': 'date range change'
      });
    }
  }, {
    key: 'updateFromAndToDateLabel',
    value: function updateFromAndToDateLabel(value, yearOrMonth, fromOrTo) {
      var performanceFromDate = _date_formatter2.default.convertDateToLastDayOfMonth(this["dropdown-toggle-from"].value);
      var performanceToDate = _date_formatter2.default.convertDateToLastDayOfMonth(this["dropdown-toggle-to"].value);
      var isFromDate = fromOrTo === "from";

      if (isFromDate) {
        var fromDateUIValue = (0, _moment2.default)(performanceFromDate).set(yearOrMonth, value).format(this.uiDateFormat(this.props.numberFormat));
        var selectedFromDate = _date_formatter2.default.convertDateToLastDayOfMonth(fromDateUIValue);
        this["dropdown-toggle-from"].value = _date_formatter2.default.getDateInSpecificFormat(selectedFromDate, this.uiDateFormat(this.props.numberFormat));
        this.updateMonthYearDropDownListSelectedValue(this.fromMonthDropdownRef, fromOrTo + '-' + yearOrMonth, value);
        this.updateMonthYearDropDownListSelectedValue(this.fromYearDropdownRef, fromOrTo + '-' + yearOrMonth, value);
      } else {
        var toDateUIValue = (0, _moment2.default)(performanceToDate).set(yearOrMonth, value).format(this.uiDateFormat(this.props.numberFormat));
        var selectedToDate = _date_formatter2.default.convertDateToLastDayOfMonth(toDateUIValue);
        this["dropdown-toggle-to"].value = _date_formatter2.default.getDateInSpecificFormat(selectedToDate, this.uiDateFormat(this.props.numberFormat));
        this.updateMonthYearDropDownListSelectedValue(this.toMonthDropdownRef, fromOrTo + '-' + yearOrMonth, value);
        this.updateMonthYearDropDownListSelectedValue(this.toYearDropdownRef, fromOrTo + '-' + yearOrMonth, value);
      }
    }
  }, {
    key: 'updateMonthYearDropDownListSelectedValue',
    value: function updateMonthYearDropDownListSelectedValue(ref, key, value) {
      ref.current.getWrappedInstance().updateValue("dropdown-toggle-" + key, value);
    }
  }, {
    key: 'dateIsInDataSet',
    value: function dateIsInDataSet(date) {
      return (0, _moment2.default)(date).isBetween(this.minDate, this.maxDate, null, includeBetweenDates);
    }
  }, {
    key: 'selectedDateIsBeforeMinDate',
    value: function selectedDateIsBeforeMinDate(date) {
      return (0, _moment2.default)(date).isBefore(this.props.minStartDate);
    }
  }, {
    key: 'selectedDateIsBeforeMinAvailableDate',
    value: function selectedDateIsBeforeMinAvailableDate(date) {
      return (0, _moment2.default)(date).isBefore(this.minDateInEdpiFormat);
    }
  }, {
    key: 'selectedDateIsBeforeOrSameMinDate',
    value: function selectedDateIsBeforeOrSameMinDate(date) {
      return (0, _moment2.default)(date).isSameOrBefore(this.minDateInEdpiFormat);
    }
  }, {
    key: 'selectedDateIsAfterMaxDate',
    value: function selectedDateIsAfterMaxDate(date) {
      return (0, _moment2.default)(date).isAfter(this.maxDateInEdpiFormat);
    }
  }, {
    key: 'getLastDateOfMonthOfData',
    value: function getLastDateOfMonthOfData(date) {
      var lastDateOfMonth = _date_formatter2.default.convertDateToLastDayOfMonth(date);
      var startDateOfMonth = _date_formatter2.default.convertDateToStartDayOfMonth(date);
      var lastDataOfMonth = (0, _ramda.last)(_collection_utility.CollectionUtility.filter(this.props.performanceDataForChart, function (performance) {
        return (0, _moment2.default)(performance.epochDate).isSameOrBefore(lastDateOfMonth) && (0, _moment2.default)(performance.epochDate).isSameOrAfter(startDateOfMonth);
      }));
      return (0, _ramda.isNil)(lastDataOfMonth) ? lastDateOfMonth : lastDataOfMonth.date;
    }
  }, {
    key: 'onBlurCustomDate',
    value: function onBlurCustomDate(e) {
      this.setCustomFromAndToDates(e);
      this.resetErrorState();
    }
  }, {
    key: 'setCustomDateRangeDropdown',
    value: function setCustomDateRangeDropdown() {
      this['dropdown-label-dateRange'].text = 'Custom Date Range';

      this.setState({
        selectedDateOption: 'Custom Date Range',
        selectedDateOptionTranslateKey: 'dropdown-custom-date-range',
        selectedDateOptionValue: 'custom'
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var newAmount = this.amountFilterRef.current.value;
      var numericAmount = void 0;
      numericAmount = newAmount.match(/\d/g);
      if (!(0, _ramda.isNil)(numericAmount)) {
        numericAmount = Number(numericAmount.join(""));
      }
      if (numericAmount > 10000.00 || numericAmount < 100000000000.00) {
        this.setState({
          error: "moderate"
        });
        this.props.tooltip.closeTooltip();
      }
      if (numericAmount !== this.state.initialAmount) {
        this.setNewAmount(numericAmount);
      }
    }
  }, {
    key: 'onRegularSavingAmtBlur',
    value: function onRegularSavingAmtBlur() {
      var newAmount = this.regularSavingAmountFilterRef.current.value;
      var numericAmount = void 0;
      numericAmount = newAmount.match(/\d/g);
      if (!(0, _ramda.isNil)(numericAmount)) {
        numericAmount = Number(numericAmount.join(""));
      }
      if (numericAmount > 50.00 || numericAmount < 10000.00) {
        this.setState({
          error: "moderate"
        });
        this.props.tooltip.closeTooltip();
      }
      if (numericAmount !== this.state.regularSavingAmount) {
        this.setRegularSavingAmount(numericAmount);
      }
    }
  }, {
    key: 'onClickCustomDate',
    value: function onClickCustomDate() {
      if (this.state.selectedDateOptionValue !== 'custom') {
        this.setCustomDateRangeDropdown();
      }
    }
  }, {
    key: 'onChangeCustomDateFrom',
    value: function onChangeCustomDateFrom() {
      var fromDate = (0, _jquery2.default)('#customDateFromFilter').val();
      var edpiFormattedFromDate = _date_formatter2.default.convertDateToLastDayOfMonth(fromDate, 'YYYY-MM');
      var edpiFormattedToDate = _date_formatter2.default.convertDateToLastDayOfMonth(this.state.toDateValue, 'YYYY-MM');
      var dateRangeGreaterThanAYear = _date_formatter2.default.dateRangeIsGreaterThanAYear(edpiFormattedFromDate, edpiFormattedToDate);
      var errorMsg = "From Date has to be less than To Date and at least 1 year.";

      if ((0, _moment2.default)(fromDate).isBetween(this.minDate, this.maxDate, null, includeBetweenDates)) {
        if ((0, _moment2.default)(this.state.toDateValue).isBefore(fromDate)) {
          this.setState({ toDateValue: "", fromDateValue: fromDate });
        } else if (!dateRangeGreaterThanAYear) {
          this.renderToolTipErrorMessage("customDateFromFilter", setTooltipWrapper(errorMsg));
        } else {
          var filteredData = this.getFilteredDataByDateRange(fromDate, this.state.toDateValue);
          this.setState({ fromDateValue: fromDate, performanceChartData: filteredData });
          this.props.tooltip.closeTooltip();
        }
      }
    }
  }, {
    key: 'onChangeCustomDateTo',
    value: function onChangeCustomDateTo() {
      var toDate = (0, _jquery2.default)('#customDateToFilter').val();
      var edpiFormattedToDate = _date_formatter2.default.convertDateToLastDayOfMonth(toDate, 'YYYY-MM');
      var edpiFormattedFromDate = _date_formatter2.default.convertDateToLastDayOfMonth(this.state.fromDateValue, 'YYYY-MM');
      var dateRangeGreaterThanAYear = _date_formatter2.default.dateRangeIsGreaterThanAYear(edpiFormattedFromDate, edpiFormattedToDate);
      var errorMsg = _string_utility2.default.renderFormattedLabel("The date range must be at least 1 year.", "pdp-performance-chart-error-message-invalid-date-range");

      if ((0, _moment2.default)(toDate).isBetween(this.minDate, this.maxDate, null, includeBetweenDates)) {
        if ((0, _moment2.default)(toDate).isBefore(this.state.fromDateValue)) {
          this.setState({ toDateValue: toDate, fromDateValue: "" });
          this.setState({ toDateValue: toDate, fromDateValue: "" });
        } else if (!dateRangeGreaterThanAYear) {
          this.renderToolTipErrorMessage("customDateToFilter", setTooltipWrapper(errorMsg));
        } else {
          var filteredData = this.getFilteredDataByDateRange(this.state.fromDateValue, toDate);
          this.setState({ toDateValue: toDate, performanceChartData: filteredData });
          this.props.tooltip.closeTooltip();
        }
      }
    }
  }, {
    key: 'setNewAmount',
    value: function setNewAmount(numericAmount) {
      var minimumAmount = this.getDefaultInitialAmount();
      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints || [], 'PERFORMANCE_CHART_MIN_AMOUNT_5K')) {
        minimumAmount = 5000;
      }
      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints || [], 'PERFORMANCE_CHART_INITIAL_AMOUNT_ZERO')) {
        minimumAmount = 0;
      }
      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).formattingRules || [], 'PERFORMANCE_CHART_MIN_AMOUNT_2500')) {
        minimumAmount = 2500;
      }
      var displayValue = this.getFormattedValue(numericAmount);
      if (minimumAmount === 0 && numericAmount === 0) {
        if (this.state.regularSavingAmountFrequency == null) {
          this.setState({ regularSavingAmountFrequency: "Monthly", regularSavingAmountFrequencyTranslatedKey: "pdp-perf-regular-saving-amount-monthly-label" });
        }
        if (this.state.regularSavingAmount == null) {
          this.setState({
            regularSavingAmount: 50
          });
          this.regularSavingAmountFilterRef.current.value = this.getFormattedValue(50);
        }
        this.setState({ initialAmount: numericAmount });
        this.amountFilterRef.current.value = displayValue;
        this.props.tooltip.closeTooltip();
      } else if (numericAmount < minimumAmount || numericAmount > 100000000000.00) {
        var tooltipMessage = (0, _ramda.cond)([[(0, _ramda.lt)(_ramda.__, minimumAmount), (0, _ramda.always)(_string_utility2.default.renderFormattedLabel('Initial amount cannot be less than ' + this.getFormattedValue(minimumAmount) + '.', 'pdp-performance-chart-error-initial-amount-min', { amount: this.getFormattedValue(minimumAmount) }))], [(0, _ramda.gt)(_ramda.__, 100000000000.00), (0, _ramda.always)(_string_utility2.default.renderFormattedLabel('Initial amount cannot be greater than ' + this.props.currencyCode + '100bn.', 'pdp-performance-chart-error-initial-amount-max', { currencyCode: this.props.currencyCode }))]]);

        var tooltipMsg = tooltipMessage(numericAmount);

        this.renderToolTipErrorMessage("amountFilter", setTooltipWrapper(tooltipMsg));
        (0, _jquery2.default)('#amountFilter').blur();
      } else {
        this.setState({ initialAmount: numericAmount });
        this.amountFilterRef.current.value = displayValue;
        this.props.tooltip.closeTooltip();
      }

      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": "growth of hypothetical investment chart",
        "eventLabel": "initial amount - " + displayValue
      });
    }
  }, {
    key: 'setRegularSavingAmount',
    value: function setRegularSavingAmount(numericAmount) {
      var minimumAmount = 50;
      var maxAmount = 10000;
      var displayValue = this.getFormattedValue(numericAmount);
      if (numericAmount == null) {
        this.setState({ regularSavingAmountFrequency: null, regularSavingAmountFrequencyTranslatedKey: null });
      } else if (numericAmount < minimumAmount || numericAmount > maxAmount) {
        var tooltipMessage = (0, _ramda.cond)([[(0, _ramda.lt)(_ramda.__, minimumAmount), (0, _ramda.always)(_string_utility2.default.renderFormattedLabel('Regular savings amount cannot be less than ' + this.getFormattedValue(minimumAmount) + '.', 'pdp-performance-chart-error-regular-saving-amount-min', { amount: this.getFormattedValue(minimumAmount) }))], [(0, _ramda.gt)(_ramda.__, 10000.00), (0, _ramda.always)(_string_utility2.default.renderFormattedLabel('Regular savings amount cannot be greater than ' + this.getFormattedValue(maxAmount) + '.', 'pdp-performance-chart-error-regular-saving-amount-max', { amount: this.getFormattedValue(maxAmount) }))]]);

        var tooltipMsg = tooltipMessage(numericAmount);

        this.renderToolTipErrorMessage("regular-saving-amountFilter", setTooltipWrapper(tooltipMsg));
        (0, _jquery2.default)('#regular-saving-amountFilter').blur();
      } else {
        this.setState({ regularSavingAmount: numericAmount });
        this.regularSavingAmountFilterRef.current.value = displayValue;
        this.props.tooltip.closeTooltip();
        if (this.state.regularSavingAmountFrequency == null) {
          var _tooltipMsg = _string_utility2.default.renderFormattedLabel("Frequency must be selected.", "pdp-performance-chart-regular-saving-amount-frequency-error");
          this.renderToolTipErrorMessage("regularSavingAmountFrequency", setTooltipWrapper(_tooltipMsg));
        }
      }
    }
  }, {
    key: 'getRegularSavingAmountFrequency',
    value: function getRegularSavingAmountFrequency() {
      var _this3 = this;

      var items = [];
      var options = [{
        value: "Monthly",
        displayValue: _string_utility2.default.getLocalizedString(this.props.intl, "Monthly", "pdp-perf-regular-saving-amount-monthly-label")
      }, {
        value: "Quarterly",
        displayValue: _string_utility2.default.getLocalizedString(this.props.intl, "Quarterly", "pdp-perf-regular-saving-amount-quarterly-label")
      }];
      mapIndexed(function (option, index) {
        items.push(_react2.default.createElement(
          'div',
          { key: index, 'data-option-value': option.value, 'data-display-value': option.displayValue,
            className: 'dropdown-list-item', onClick: _this3.selectedRegularSavingAmountFrequency },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': option.value,
              'data-display-value': option.displayValue },
            option.displayValue
          )
        ));
      }, options);
      return items;
    }
  }, {
    key: 'selectedRegularSavingAmountFrequency',
    value: function selectedRegularSavingAmountFrequency(event) {
      var regularSavingAmtFrequency = event.target.getAttribute("data-option-value");
      this.setState({ regularSavingAmountFrequency: regularSavingAmtFrequency,
        regularSavingAmountFrequencyTranslatedKey: regularSavingAmtFrequency === 'Monthly' ? "pdp-perf-regular-saving-amount-monthly-label" : "pdp-perf-regular-saving-amount-quarterly-label" });
      if (this.state.regularSavingAmount == null) {
        var tooltipMsg = _string_utility2.default.renderFormattedLabel("Regular saving amount must be entered.", "pdp-performance-chart-regular-saving-amount-error");
        this.renderToolTipErrorMessage("regular-saving-amountFilter", setTooltipWrapper(tooltipMsg));
        (0, _jquery2.default)('#regular-saving-amountFilter').blur();
      } else {
        this.setState({
          error: "moderate"
        });
        this.props.tooltip.closeTooltip();
      }
    }
  }, {
    key: 'renderToolTipErrorMessage',
    value: function renderToolTipErrorMessage(elementId, tooltipMessage) {
      var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var el = document.getElementById(elementId);
      var elHeight = el.offsetHeight;
      var elWidth = el.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var offsetArrowHeight = 4;
      var elPadding = 10;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var toolTipWidth = el.offsetWidth;

      var elOffset = (0, _ramda.mergeDeepRight)({
        top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 8,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipWidth,
        showCrossIcon: false
      }, additionalProps);

      this.setState({
        error: "extreme",
        errorId: elementId
      });
      this.props.tooltip.openTooltip(elOffset, null, tooltipMessage, false);
    }
  }, {
    key: 'createPerformancePlotPoints',
    value: function createPerformancePlotPoints(performanceData, initialAmount, regularSavings, regularSavingsFrequency) {
      var runningAmount = initialAmount;
      var runningAmountForPerCal = 1 + 0.00;
      var runingSharePriceAmountForPerCal = 1 + 0.00;
      var runningBenchmarkAmountForPerCal = 1 + 0.00;
      var runingSharePriceAmount = initialAmount;
      var runningBenchmarkAmount = initialAmount;
      var regularSavingAmount = initialAmount;

      var showSharePriceReturns = false;
      var showBenchmarkReturnsEmea = false;
      var showRegularSavingAmount = false;
      var isDailyETF = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'DAILY_ETF_FUND');

      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE') || _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHARECLASS_NAV')) {
        return this.plotPointsShareclassNAVBenchmark(performanceData, initialAmount);
      }

      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHAREPRICE_PERFORMANCE')) {
        showSharePriceReturns = true;
      }

      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE_EMEA') && this.props.performanceDataForChart.filter(function (item) {
        return !(0, _ramda.isNil)(item.benchmarkPrice);
      }).length > 0) {
        showBenchmarkReturnsEmea = true;
      }

      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART') && this.state.regularSavingAmount != null && this.state.regularSavingAmountFrequency != null) {
        showRegularSavingAmount = true;
      }

      var plotPoints = [];
      var percentage = void 0,
          date = void 0,
          amount = void 0,
          amountPercentageInc = void 0,
          sharePricePct = void 0,
          sharePriceAmount = void 0,
          sharePricePercentageInc = void 0,
          benchmarkAmount = void 0,
          benchmarkPricePct = void 0,
          benchmarkPricePctPreviousDay = void 0,
          benchmarkPercentageInc = void 0,
          noOfMonthInQuarter = 0,
          valueWithRegularSavings = void 0,
          start = 0;
      var newPlotPoint = void 0,
          date1DayBeforeFirstPerformanceReturn = void 0,
          date1MonthBeforeFirstPerformanceReturn = void 0,
          firstDate = void 0;
      if (isDailyETF) {
        date1DayBeforeFirstPerformanceReturn = (0, _moment2.default)(getDateFromObject(performanceData[0])).subtract(1, 'days').format('YYYY-MM-DD');
      } else if (this.isInceptionMonth(getDateFromObject(performanceData[0]))) {
        initialAmount = Math.round(initialAmount * (1 + this.state.inceptionMonthROR));
        runningAmount = initialAmount;
        firstDate = performanceData[0].date;
        start = 1;
      } else {
        date1MonthBeforeFirstPerformanceReturn = _date_formatter2.default.getMonthEndDateBeforeNMonths(getDateFromObject(performanceData[0]), 1);
        if (this.isInceptionMonth(date1MonthBeforeFirstPerformanceReturn)) {
          initialAmount = Math.round(initialAmount * (1 + this.state.inceptionMonthROR));
          runningAmount = initialAmount;
        }
        firstDate = date1MonthBeforeFirstPerformanceReturn;
      }

      newPlotPoint = {
        date: !(0, _functional_utility.isNilOrEmpty)(date1DayBeforeFirstPerformanceReturn) ? date1DayBeforeFirstPerformanceReturn : firstDate,
        amount: initialAmount,
        amountPercentageInc: '0%',
        sharePriceAmount: showSharePriceReturns ? initialAmount : null,
        sharePricePercentageInc: showSharePriceReturns ? '0%' : null,
        benchmarkAmount: showBenchmarkReturnsEmea || isDailyETF ? initialAmount : null,
        benchmarkPercentageInc: showBenchmarkReturnsEmea || isDailyETF ? '0%' : null,
        regularSavingAmount: showRegularSavingAmount ? initialAmount : null
      };

      plotPoints.push(newPlotPoint);
      for (var i = start; i < performanceData.length; i++) {
        date = performanceData[i].date;
        noOfMonthInQuarter += 1;

        percentage = performanceData[i].cumulativeNoLoadPercentage;
        amount = Math.round(runningAmount * (1 + percentage));
        valueWithRegularSavings = this.calculateValueWithRegularSavings(regularSavings, regularSavingsFrequency, amount, noOfMonthInQuarter);
        amount = valueWithRegularSavings ? valueWithRegularSavings : amount;
        runningAmountForPerCal *= 1 + percentage;
        amountPercentageInc = Math.round((runningAmountForPerCal - 1) * 100);

        if (showSharePriceReturns) {
          sharePricePct = performanceData[i].sharePricePercentageReturn;
          sharePriceAmount = Math.round(runingSharePriceAmount * (1 + sharePricePct));
          valueWithRegularSavings = this.calculateValueWithRegularSavings(regularSavings, regularSavingsFrequency, sharePriceAmount, noOfMonthInQuarter);
          sharePriceAmount = valueWithRegularSavings ? valueWithRegularSavings : sharePriceAmount;
          runingSharePriceAmount = sharePriceAmount;
          runingSharePriceAmountForPerCal *= 1 + sharePricePct;
          sharePricePercentageInc = Math.round((runingSharePriceAmountForPerCal - 1) * 100);
        }

        if (showBenchmarkReturnsEmea) {
          benchmarkPricePct = performanceData[i].benchmarkPrice;
          benchmarkAmount = Math.round(runningBenchmarkAmount * (1 + benchmarkPricePct));
          valueWithRegularSavings = this.calculateValueWithRegularSavings(regularSavings, regularSavingsFrequency, benchmarkAmount, noOfMonthInQuarter);
          benchmarkAmount = valueWithRegularSavings ? valueWithRegularSavings : benchmarkAmount;
          runningBenchmarkAmount = benchmarkAmount;
          runningBenchmarkAmountForPerCal *= 1 + benchmarkPricePct;
          benchmarkPercentageInc = Math.round((runningBenchmarkAmountForPerCal - 1) * 100);
        }

        if (isDailyETF) {
          if (i === 0) {
            benchmarkPricePct = performanceData[i].benchmarkCumulativeTrailingReturnPercentage;
            benchmarkAmount = Math.round(runningBenchmarkAmount * (1 + benchmarkPricePct));
            runningBenchmarkAmount = benchmarkAmount;
            runningBenchmarkAmountForPerCal *= 1 + benchmarkPricePct;
            benchmarkPercentageInc = Math.round((runningBenchmarkAmountForPerCal - 1) * 100);
            benchmarkPricePctPreviousDay = performanceData[i].benchmarkPrice;
          } else {
            benchmarkPricePct = performanceData[i].benchmarkPrice;
            if ((0, _functional_utility.isNilOrEmpty)(benchmarkPricePct)) {
              benchmarkPricePct = benchmarkPricePctPreviousDay;
            }
            if (!(0, _functional_utility.isNilOrEmpty)(benchmarkPricePct) && !(0, _functional_utility.isNilOrEmpty)(benchmarkPricePctPreviousDay)) {
              benchmarkAmount = Math.round(runningBenchmarkAmount + runningBenchmarkAmount * ((benchmarkPricePct - benchmarkPricePctPreviousDay) / benchmarkPricePctPreviousDay));
              runningBenchmarkAmount = benchmarkAmount;
              runningBenchmarkAmountForPerCal *= 1 + benchmarkPricePct;
              benchmarkPercentageInc = Math.round((runningBenchmarkAmountForPerCal - 1) * 100);
            }
            benchmarkPricePctPreviousDay = benchmarkPricePct;
          }
        }

        if (showRegularSavingAmount) {
          if (this.state.regularSavingAmountFrequency === "Quarterly") {
            if (noOfMonthInQuarter === 3) {
              regularSavingAmount += this.state.regularSavingAmount;
            }
          } else {
            regularSavingAmount += this.state.regularSavingAmount;
          }
        }

        if (regularSavingsFrequency === "Quarterly" && noOfMonthInQuarter === 3) {
          noOfMonthInQuarter = 0;
        }

        newPlotPoint = {
          date: date,
          amount: amount,
          amountPercentageInc: amountPercentageInc + '%',
          sharePriceAmount: showSharePriceReturns ? sharePriceAmount : null,
          sharePricePercentageInc: showSharePriceReturns ? sharePricePercentageInc + '%' : null,
          benchmarkAmount: showBenchmarkReturnsEmea || isDailyETF ? runningBenchmarkAmount : null,
          benchmarkPercentageInc: showBenchmarkReturnsEmea || isDailyETF ? benchmarkPercentageInc + '%' : null,
          regularSavingAmount: showRegularSavingAmount ? regularSavingAmount : null
        };
        plotPoints.push(newPlotPoint);
        runningAmount = amount;
      }

      return plotPoints;
    }
  }, {
    key: 'calculateValueWithRegularSavings',
    value: function calculateValueWithRegularSavings(regularSavings, regularSavingFrequency, value, noOfMonthInQuarter) {
      var calculatedValue = void 0;
      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART') && regularSavings !== null && regularSavingFrequency !== null) {
        if (regularSavingFrequency === "Monthly" || regularSavingFrequency === "Quarterly" && noOfMonthInQuarter === 3) {
          calculatedValue = value + regularSavings;
        }
      }
      return calculatedValue;
    }
  }, {
    key: 'plotPointsShareclassNAVBenchmark',
    value: function plotPointsShareclassNAVBenchmark(performanceData, initialAmount) {

      var plotPoints = [];
      var previousPerformanceChartDataPoint = void 0;
      var updatedPerformanceData = _collection_utility.CollectionUtility.clone(performanceData);

      if (performanceData.length !== this.props.performanceDataForChart.length) {
        for (var i = this.props.performanceDataForChart.length - 1; i >= 0; i--) {
          var current = this.props.performanceDataForChart[i];
          if ((0, _moment2.default)(current.date).isBefore(getDateFromObject(performanceData[0]))) {
            previousPerformanceChartDataPoint = current;
            updatedPerformanceData.unshift(previousPerformanceChartDataPoint);
            break;
          }
        }
      }

      if (this.props.fundTypeCode === "Mainland_HK_MRF_FUNDS") {
        for (var _i = 0; _i < updatedPerformanceData.length; _i++) {
          plotPoints.push({
            date: updatedPerformanceData[_i].date,
            amount: updatedPerformanceData[_i].shareclassNAV,
            benchmarkAmount: updatedPerformanceData[_i].benchmarkPrice
          });
        }
      } else {
        plotPoints.push({
          date: updatedPerformanceData[0].date,
          shareclassPerformance: 0,
          benchmarkPerformance: 0,
          amount: initialAmount,
          benchmarkAmount: initialAmount
        });

        for (var _i2 = 1; _i2 < updatedPerformanceData.length; _i2++) {
          var date = updatedPerformanceData[_i2].date;

          var benchmarkPerformance = 100;
          var firstBenchmarkPriceData = (0, _ramda.head)(_collection_utility.CollectionUtility.filter(updatedPerformanceData, function (data) {
            return !(0, _ramda.isNil)(data.benchmarkPrice);
          }));
          if (!(0, _ramda.isNil)(updatedPerformanceData[_i2].benchmarkPrice)) {
            benchmarkPerformance = updatedPerformanceData[_i2].benchmarkPrice / firstBenchmarkPriceData.benchmarkPrice * 100;
          }
          plotPoints.push({
            date: date,
            amount: updatedPerformanceData[_i2].shareclassNAV / updatedPerformanceData[0].shareclassNAV * 100,
            benchmarkAmount: benchmarkPerformance
          });
        }
      }

      return plotPoints;
    }
  }, {
    key: 'getTickAmounts',
    value: function getTickAmounts(calculatedPerformanceData) {
      var _NumberUtility$getMax = _number_utility2.default.getMaxAndMinAmount(['amount', 'sharePriceAmount', 'benchmarkAmount', 'regularSavingAmount'], calculatedPerformanceData, [this.state.initialAmount]),
          minAmount = _NumberUtility$getMax.minAmount,
          maxAmount = _NumberUtility$getMax.maxAmount;

      if (this.shouldApplyChartAxisPadding()) {
        minAmount -= minAmount / 10;
        maxAmount += maxAmount / 10;
      }

      return this.setTicks(minAmount, maxAmount);
    }
  }, {
    key: 'shouldApplyChartAxisPadding',
    value: function shouldApplyChartAxisPadding() {
      return !(0, _functional_utility.isNilOrEmpty)(this.props.visibleData.visibleCharts) && _collection_utility.CollectionUtility.includes(this.props.visibleData.visibleCharts, 'PERFORMANCE_CHART_YAXIS_PADDING');
    }
  }, {
    key: 'setTicks',
    value: function setTicks(startAmount, maxAmount) {
      return _number_utility2.default.getTicks(startAmount, maxAmount, this.state.initialAmount, 9);
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltip, tooltipId, ariaText) {
      var _this4 = this;

      return _react2.default.createElement(
        'span',
        { id: 'tool-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'button',
          'aria-label': 'more information about ' + ariaText,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this4, event, _this4.handleDisclosureIconClick.bind(_this4, event, tooltipId, tooltip));
          },
          onClick: function onClick(event) {
            return _this4.handleDisclosureIconClick(event, tooltipId, tooltip);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId, tooltip) {
      var el = this.getIconEl(tooltipId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var offsetArrowHeight = 4;
      var elPadding = 10;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 2
      };

      this.props.tooltip.openTooltip(elOffset, null, tooltip, true, event);
    }
  }, {
    key: 'renderPopIcon',
    value: function renderPopIcon(tooltipId) {
      var _this5 = this;

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this5, event, _this5.handlePopIconClick.bind(_this5, event));
          },
          onClick: function onClick(event) {
            return _this5.handlePopIconClick(event);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handlePopIconClick',
    value: function handlePopIconClick(event) {
      var el = event.target;
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (this.props.performanceChartHeaderDisclosure.length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      if (!(0, _ramda.isNil)(this.props.tooltip)) {
        this.props.tooltip.openTooltip(elOffset, this.props.performanceChartHeaderDisclosure, null, true, event);
      } else {
        this.props.showTooltip(event, this.props.performanceChartHeaderDisclosure);
      }
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('tool-' + tooltipId);
    }
  }, {
    key: 'addYearMapsToDateRangeArray',
    value: function addYearMapsToDateRangeArray(dateRangeArray, yearMapArray) {
      for (var index = 0; index < yearMapArray.length; index++) {
        if ((0, _moment2.default)(this.maxDate).diff((0, _moment2.default)(this.minDate), 'year') >= yearMapArray[index].years) {
          dateRangeArray.push({
            value: yearMapArray[index].value,
            displayValue: 'Last ' + yearMapArray[index].years + ' year' + (yearMapArray[index].years > 1 ? 's' : ''),
            translationKey: 'dropdown-last-' + yearMapArray[index].years + '-year' + (yearMapArray[index].years > 1 ? 's' : '')
          });
        }
      }
    }
  }, {
    key: 'dateRangeItems',
    value: function dateRangeItems() {
      var _this6 = this;

      if (this.isFundExactlyOneYearOld()) {
        var oneYearItems = this.generateDateRangeRow("0", "Since Inception", "since-inception");
        return oneYearItems;
      }

      var dateRangeArray = [];

      if (!(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && !_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'HYPO_CHART_REMOVE_INCEPTION_OPTION')) {
        dateRangeArray.push({
          value: "0",
          displayValue: "Since Inception",
          translationKey: "since-inception"
        });
      }

      var yearMapArray = [{
        years: 1,
        value: '11'
      }, {
        years: 3,
        value: '35'
      }, {
        years: 5,
        value: '59'
      }, {
        years: 10,
        value: '119'
      }, {
        years: 15,
        value: '179'
      }, {
        years: 20,
        value: '239'
      }];

      this.addYearMapsToDateRangeArray(dateRangeArray, yearMapArray);

      if (this.shouldDisplaySinceDataAvailable()) {
        dateRangeArray[0].displayValue = "Since Data Available";
        dateRangeArray[0].translationKey = "since-data-available";
      }

      var items = dateRangeArray.map(function (dateRangeOption) {
        return _this6.generateDateRangeRow(dateRangeOption.value, dateRangeOption.displayValue, dateRangeOption.translationKey);
      }).slice(0, this.state.count);

      items.push(this.generateDateRangeRow("custom", "Custom Date Range", "dropdown-custom-date-range"));
      return items;
    }
  }, {
    key: 'generateDateRangeRow',
    value: function generateDateRangeRow(value, displayValue, translationKey) {
      var _this7 = this;

      this[value + 'dropdown'] = _react2.default.createRef();
      var isLastElement = value === "custom";
      return _react2.default.createElement(
        'div',
        { 'data-option-value': value,
          tabIndex: '-1',
          'data-translation-key': translationKey,
          'data-display-value': displayValue,
          ref: this[value + 'dropdown'],
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleDropdownEvents(_this7, event, '#dateRangeFilter', value + 'dropdown', '0dropdown', isLastElement, function () {
              return _this7.setDateFilter(event);
            });
          },
          onClick: this.setDateFilter,
          className: 'dropdown-list-item',
          role: 'option' },
        _react2.default.createElement(
          'span',
          { className: 'font-light caption', 'data-option-value': value,
            'data-translation-key': translationKey, 'data-display-value': displayValue },
          _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
        )
      );
    }
  }, {
    key: 'updateInitialAmount',
    value: function updateInitialAmount() {
      var initialAmount = this.props.currencyCode + _number_utility2.default.convertToNumberWithCommas(this.state.initialAmount);
      this.amountFilterRef.current.value = initialAmount;
      this.setState({
        error: "moderate"
      });
      this.props.tooltip.closeTooltip();
    }
  }, {
    key: 'updateRegularSavingAmount',
    value: function updateRegularSavingAmount() {
      this.regularSavingAmountFilterRef.current.value = "";
      this.setState({
        error: "moderate"
      });
      this.props.tooltip.closeTooltip();
    }
  }, {
    key: 'removeRegularSavingsFrequencyError',
    value: function removeRegularSavingsFrequencyError() {
      this.setState({
        error: "moderate"
      });
      this.props.tooltip.closeTooltip();
    }
  }, {
    key: 'isChartVisible',
    value: function isChartVisible() {
      if ((0, _ramda.isNil)(this.props.performanceDataForChart) || _collection_utility.CollectionUtility.size(this.props.performanceDataForChart) < 1) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(refId) {
      var _this8 = this;

      return function (el) {
        return _this8[refId] = el;
      };
    }
  }, {
    key: 'performanceSinceFormatedMessage',
    value: function performanceSinceFormatedMessage(date) {
      return _date_formatter2.default.getTranslatedHeaderWithDate(date, 'pdp-perf-chart-from-date-performance-since', 'Performance since: {monthInWord}, {year}');
    }
  }, {
    key: 'performanceInceptionFormattedMessage',
    value: function performanceInceptionFormattedMessage(date) {
      return _date_formatter2.default.getTranslatedHeaderWithDate(date, 'pdp-perf-chart-from-date-performance-inception', 'Performance inception: {monthInWord}, {year}');
    }
  }, {
    key: 'earliestPerformanceChartData',
    value: function earliestPerformanceChartData() {
      return (0, _ramda.head)(this.props.performanceDataForChart);
    }
  }, {
    key: 'renderDateDropdown',
    value: function renderDateDropdown(fromOrToDate) {
      var isFromDropdown = fromOrToDate === "from";
      var shouldUsePerformanceSinceOptions = !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_PERFORMANCE_SINCE_OPTION');
      var performanceInceptionText = shouldUsePerformanceSinceOptions ? this.performanceSinceFormatedMessage(this.earliestPerformanceChartData().date) : this.performanceInceptionFormattedMessage((0, _moment2.default)(getDateFromObject(this.props.performanceDataForChart[0])).toDate());

      return _react2.default.createElement(
        'div',
        null,
        isFromDropdown && !(0, _fund_utility.isSGNonLiq)(this.props.country, this.props.role) && _react2.default.createElement(
          'div',
          { className: 'disclaimer margin-bottom-10 padding-top-10 padding-horizontal-10',
            'data-testid': 'from-performance-inception-date' },
          performanceInceptionText
        ),
        _react2.default.createElement(
          _click_or_escape_outside2.default,
          { id: 'month-dropdown' },
          _react2.default.createElement(_date_dropdown_component2.default, {
            ref: isFromDropdown ? this.fromMonthDropdownRef : this.toMonthDropdownRef,
            defaultValue: isFromDropdown ? _date_formatter3.MONTHS[parseInt(this.state.fromDateValue.split('-')[1], 10) - 1].value : _date_formatter3.MONTHS[parseInt(this.state.toDateValue.split('-')[1], 10) - 1].value,
            additionalClassName: 'margin-bottom-10 padding-top-10 padding-horizontal-10 fixed-height-dropdown',
            value: 'Month',
            idSuffix: isFromDropdown ? "from-month" : "to-month",
            valueClassName: 'npe-icon-down-arrow',
            dataTest: 'month-dropdown',
            changeMonthYear: this.updateFromAndToDateLabel,
            fromOrToDate: fromOrToDate,
            firstYear: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject(this.props.performanceDataForChart[0]), 'YYYY'),
            lastYear: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart)), 'YYYY'),
            readOnly: true
          })
        ),
        _react2.default.createElement(
          _click_or_escape_outside2.default,
          { id: 'year-dropdown' },
          _react2.default.createElement(_date_dropdown_component2.default, {
            ref: isFromDropdown ? this.fromYearDropdownRef : this.toYearDropdownRef,
            defaultValue: isFromDropdown ? this.state.fromDateValue.split('-')[0] : this.state.toDateValue.split('-')[0],
            additionalClassName: "margin-bottom-10 padding-horizontal-10 fixed-height-dropdown",
            value: 'Year',
            idSuffix: isFromDropdown ? "from-year" : "to-year",
            valueClassName: 'npe-icon-down-arrow',
            dataTest: 'year-dropdown',
            changeMonthYear: this.updateFromAndToDateLabel,
            fromOrToDate: fromOrToDate,
            firstYear: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject(this.props.performanceDataForChart[0]), 'YYYY'),
            lastYear: _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(this.props.performanceDataForChart)), 'YYYY'),
            readOnly: true
          })
        )
      );
    }
  }, {
    key: 'resetErrorState',
    value: function resetErrorState() {
      if (this.state.error === "extreme") {
        this.setState({
          error: "moderate",
          errorId: null
        });
        this["dropdown-toggle-from"].value = _date_formatter2.default.getDateInSpecificFormat(this.state.performanceFromDate, this.uiDateFormat(this.props.numberFormat));
        this["dropdown-toggle-to"].value = _date_formatter2.default.getDateInSpecificFormat(this.state.performanceToDate, this.uiDateFormat(this.props.numberFormat));
        this.props.tooltip.closeTooltip();
      }
    }
  }, {
    key: 'resetErrorStateBP1',
    value: function resetErrorStateBP1() {
      if (this.state.error === "extreme") {
        this.setState({
          error: "moderate",
          errorId: null
        });

        (0, _jquery2.default)("#customDateFromFilter").val(_date_formatter2.default.getDateInSpecificFormat(this.state.performanceFromDate, yearMonthFormat));
        (0, _jquery2.default)("#customDateToFilter").val(_date_formatter2.default.getDateInSpecificFormat(this.state.performanceToDate, yearMonthFormat));
        this.props.tooltip.closeTooltip();
      }
    }
  }, {
    key: 'getFormattedValue',
    value: function getFormattedValue(value) {
      if (value === 0) {
        return '' + this.props.currencyCode + value;
      } else {
        return '' + this.props.currencyCode + _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(value), this.props.numberFormat);
      }
    }
  }, {
    key: 'renderPerformanceChartLegend',
    value: function renderPerformanceChartLegend(plotPoints) {
      var isBenchmarkNotEmpty = this.props.performanceDataForChart.filter(function (item) {
        return !(0, _ramda.isNil)(item.benchmarkPrice);
      }).length > 0;
      if ((0, _ramda.includes)('PERFORMANCE_CHART_LEGEND', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props))) {
        var items = [];
        if (!(0, _ramda.isNil)(this.props.shareclassName)) {
          items.push(_react2.default.createElement(
            'div',
            { className: 'tag chart-legend' },
            (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Pink),
            _react2.default.createElement(
              'span',
              {
                className: 'font-regular',
                style: { color: "#000000" },
                'data-testid': 'performance-chart-shareclass-longname-legend' },
              (0, _fund_utility.isSGNonLiq)(this.props.country, this.props.role) ? 'Fund' : this.props.shareclassName,
              ' '
            )
          ));
        }
        if (((0, _fund_utility.isSGNonLiq)(this.props.country, this.props.role) || !(0, _ramda.isNil)(this.props.benchmarkLongName)) && isBenchmarkNotEmpty) {
          items.push(_react2.default.createElement(
            'div',
            { className: 'tag chart-legend' },
            (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Brown),
            _react2.default.createElement(
              'span',
              {
                style: { color: "#000000" },
                'data-testid': 'performance-chart-benchmark-longname-legend',
                className: 'font-regular'
              },
              (0, _fund_utility.isSGNonLiq)(this.props.country, this.props.role) ? 'Benchmark' : this.props.benchmarkLongName
            )
          ));
        }
        if (!(0, _ramda.isNil)(this.props.benchmarkRestructuringDate) && (0, _moment2.default)(this.props.benchmarkRestructuringDate).isSameOrAfter(getDateFromObject(plotPoints[0]))) {
          items.push(_react2.default.createElement(
            'div',
            { className: 'tag chart-legend' },
            (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Blue),
            _react2.default.createElement(
              'span',
              {
                className: 'font-regular',
                style: { color: "#000000" },
                'data-testid': 'performance-chart-rebenchmark-date-legend' },
              _date_formatter2.default.getDateInSlashFormat(this.props.benchmarkRestructuringDate, "DD/MM/YYYY")
            )
          ));
        }

        return _react2.default.createElement(
          'div',
          { 'data-testid': 'performance-chart-legend', className: 'font-light font-16 padding-top-10' },
          items
        );
      }

      if ((0, _ramda.includes)('PERFORMANCE_CHART_SHOW_SHAREPRICE_PERFORMANCE', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props))) {
        var _items = [];
        _items.push(_react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Pink),
          _react2.default.createElement(
            'span',
            { className: 'font-regular', style: { color: "#000000" },
              'data-testid': 'performance-chart-nav-legend' },
            'NAV'
          )
        ));
        _items.push(_react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Green),
          _react2.default.createElement(
            'span',
            { className: 'font-regular display-inline-block', style: { color: "#000000" },
              'data-testid': 'performance-chart-share-price-legend' },
            'Share Price'
          )
        ));
        if (isBenchmarkNotEmpty && ((0, _ramda.includes)('PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE_EMEA', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props)) || (0, _ramda.includes)('DAILY_ETF_FUND', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props)))) {
          _items.push(_react2.default.createElement(
            'div',
            { className: 'tag chart-legend' },
            (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Brown),
            _react2.default.createElement(
              'span',
              { className: 'font-regular display-inline-block', style: { color: "#000000" },
                'data-testid': 'performance-chart-benchmark-legend' },
              'Benchmark'
            )
          ));
        }
        return _react2.default.createElement(
          'div',
          { className: 'margin-bottom-10' },
          _items
        );
      }

      if ((0, _ramda.includes)('SHOW_DATA_POINT_LABELS_FOR_HYPOCHART', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props))) {
        var _items2 = [];
        _items2.push(_react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Pink),
          _react2.default.createElement(
            'span',
            { className: 'font-regular', style: { color: "#000000" },
              'data-testid': 'performance-chart-label-legend' },
            _string_utility2.default.renderFormattedLabel("", "pdp-performance-chart-tooltip", { fundType: this.props.fundTypeCode })
          )
        ));
        if (isBenchmarkNotEmpty && ((0, _ramda.includes)('PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE_EMEA', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props)) || (0, _ramda.includes)('DAILY_ETF_FUND', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props)))) {
          _items2.push(_react2.default.createElement(
            'div',
            { className: 'tag chart-legend' },
            (0, _legendCircle.createLegendCircle)(_constants.CHART_COLORS.Brown),
            _react2.default.createElement(
              'span',
              { className: 'font-regular display-inline-block', style: { color: "#000000" },
                'data-testid': 'performance-chart-benchmark-legend' },
              _string_utility2.default.renderFormattedLabel("Benchmark", "Benchmark")
            )
          ));
        }
        return _react2.default.createElement(
          'div',
          { className: 'margin-bottom-10' },
          _items2
        );
      }
    }
  }, {
    key: 'renderCustomDateFilters',
    value: function renderCustomDateFilters(isRegularSavingsAndDesktop) {
      var _this9 = this;

      var breakpoint = this.props.breakpoint;
      var _state3 = this.state,
          fromDateValue = _state3.fromDateValue,
          toDateValue = _state3.toDateValue,
          performanceFromDate = _state3.performanceFromDate,
          performanceToDate = _state3.performanceToDate,
          errorId = _state3.errorId,
          error = _state3.error;


      if (this.isFundExactlyOneYearOld()) {
        return null;
      }

      if (breakpoint < 3) {
        var errorFromOrToDate = error === "extreme" && (errorId === "customDateFromFilter" || errorId === "customDateToFilter");
        var errorClassName = "height-38 body2 border-red ";
        var inputClass = "height-38 body2";
        return _react2.default.createElement(
          'div',
          {
            className: _functional_utility2.default.isTabOrMobileBreakpoint(breakpoint, "fromToContainer height-45 font-light margin-top-20", " display-inline-block ") + ' ' },
          _react2.default.createElement(
            'div',
            {
              className: _functional_utility2.default.isTabOrMobileBreakpoint(breakpoint, "width-percent-45 display-inline-block pull-left", "display-inline-block margin-top-0 margin-right-10 width-percent-45 text-top") + ' ' },
            _react2.default.createElement(
              'div',
              {
                className: 'margin-bottom-5 visible-lg-block tag-2' },
              _string_utility2.default.renderFormattedLabel("FROM", "pdp-perf-chart-date-from-label")
            ),
            _react2.default.createElement(
              'div',
              { className: 'show-error' },
              errorFromOrToDate ? _react2.default.createElement('input', { 'data-testid': 'custom-range-from-date', type: 'text', className: errorClassName }) : _react2.default.createElement('input', { 'data-testid': 'custom-range-from-date', type: 'month', className: inputClass,
                value: fromDateValue, id: 'customDateFromFilter', onChange: this.onChangeCustomDateFrom,
                onClick: this.onClickCustomDate,
                min: this.minDate, max: this.maxDateForFromDate }),
              errorFromOrToDate && _react2.default.createElement(
                'span',
                { className: 'icon-close', onClick: this.resetErrorStateBP1 },
                ' '
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: _functional_utility2.default.isTabOrMobileBreakpoint(breakpoint, "width-percent-45 display-inline-block pull-right", "display-inline-block margin-top-0 margin-right-10 width-percent-45 text-top") + ' ' },
            _react2.default.createElement(
              'div',
              {
                className: 'margin-bottom-5 visible-lg-block tag-2' },
              _string_utility2.default.renderFormattedLabel("TO", "pdp-perf-chart-date-to-label")
            ),
            _react2.default.createElement(
              'div',
              { className: 'show-error' },
              errorFromOrToDate ? _react2.default.createElement('input', { 'data-testid': 'custom-range-to-date', type: 'text', className: errorClassName }) : _react2.default.createElement('input', { 'data-testid': 'custom-range-to-date', type: 'month', className: inputClass,
                value: toDateValue, id: 'customDateToFilter', onChange: this.onChangeCustomDateTo,
                onClick: this.onClickCustomDate,
                min: this.minDateForToDate, max: this.maxDate }),
              errorFromOrToDate && _react2.default.createElement(
                'span',
                { className: 'icon-close', onClick: this.resetErrorStateBP1 },
                ' '
              )
            )
          )
        );
      } else {
        var parentWidth = breakpoint === 3 ? "width-percent-50 margin-top-10" : "width-percent-15";
        var toDateDropDownWidth = breakpoint === 3 ? "margin-left-10 width-percent-97" : "width-percent-90";
        var fromDateDropDownWidth = breakpoint === 3 ? "width-percent-97" : "width-percent-90";
        return [_react2.default.createElement(
          _click_or_escape_outside2.default,
          {
            id: 'from-dropdown',
            key: 'FROM',
            additionalClassName: 'display-inline-block ' + parentWidth,
            onClose: function onClose(e) {
              _this9.setCustomFromAndToDates(e, "from-dropdown");
            }
          },
          _react2.default.createElement(_date_dropdown_component2.default, {
            label: _string_utility2.default.renderFormattedLabel("FROM", "pdp-perf-chart-date-from-label"),
            idSuffix: 'from',
            value: _date_formatter2.default.getDateInSpecificFormat(performanceFromDate, this.uiDateFormat(this.props.numberFormat)),
            additionalClassName: 'margin-right-10 display-inline-block ' + fromDateDropDownWidth,
            valueClassName: "date-with-calendar-icon",
            dropdownContent: this.renderDateDropdown("from"),
            shouldShowErrorState: errorId === "dropdown-toggle-from",
            setCustomFromAndToDates: this.setCustomFromAndToDates,
            dataTest: 'from-date',
            readOnly: false,
            onKeyPress: this.onCustomDateFilterKeyPress,
            onBlur: this.onBlurCustomDate,
            setCustomDateRangeDropdown: this.setCustomDateRangeDropdown,
            resetErrorState: this.resetErrorState,
            setRef: this.setRef('dropdown-toggle-from'),
            isRegularSavingsAndDesktop: isRegularSavingsAndDesktop
          })
        ), _react2.default.createElement(
          _click_or_escape_outside2.default,
          {
            id: 'to-dropdown', fund_explorer_header: true,
            key: 'TO',
            additionalClassName: 'display-inline-block ' + parentWidth,
            onClose: function onClose(e) {
              _this9.setCustomFromAndToDates(e, "to-dropdown");
            }
          },
          _react2.default.createElement(_date_dropdown_component2.default, {
            label: _string_utility2.default.renderFormattedLabel("TO", "pdp-perf-chart-date-to-label"),
            idSuffix: 'to',
            valueClassName: "date-with-calendar-icon",
            value: _date_formatter2.default.getDateInSpecificFormat(performanceToDate, this.uiDateFormat(this.props.numberFormat)),
            additionalClassName: 'margin-right-10 display-inline-block ' + toDateDropDownWidth,
            dropdownContent: this.renderDateDropdown("to"),
            shouldShowErrorState: errorId === "dropdown-toggle-to",
            setCustomFromAndToDates: this.setCustomFromAndToDates,
            dataTest: 'to-date',
            readOnly: false,
            onKeyPress: this.onCustomDateFilterKeyPress,
            onBlur: this.onBlurCustomDate,
            setCustomDateRangeDropdown: this.setCustomDateRangeDropdown,
            resetErrorState: this.resetErrorState,
            setRef: this.setRef('dropdown-toggle-to'),
            isRegularSavingsAndDesktop: isRegularSavingsAndDesktop
          })
        )];
      }
    }
  }, {
    key: 'trackChartDownload',
    value: function trackChartDownload() {
      var shouldShowPerAdvTitle = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_PER_ADV_TITLE');
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": shouldShowPerAdvTitle ? 'performance chart' : 'growth of hypothetical investment chart',
        "eventLabel": "download chart data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      if (this.isChartVisible()) {
        return null;
      }

      var _state4 = this.state,
          error = _state4.error,
          errorId = _state4.errorId;

      var plotPoints = this.createPerformancePlotPoints(this.state.performanceChartData, this.state.initialAmount, this.state.regularSavingAmount, this.state.regularSavingAmountFrequency);
      var yTicks = this.getTickAmounts(plotPoints);
      var approxValue = plotPoints[plotPoints.length - 1].amount;
      var approxPercentage = Math.round(PerformanceChartParent.calculatePercentageIncrease(approxValue, this.state.initialAmount));
      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=performanceChart' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale());

      if (!(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_DOWNLOAD_CUSTOM_SELECTION')) {
        var regularSavingsAmount = (0, _functional_utility.isNilOrEmpty)(this.state.regularSavingAmount) ? '' : this.state.regularSavingAmount;
        var regularSavingsFrequency = (0, _functional_utility.isNilOrEmpty)(this.state.regularSavingAmountFrequency) ? '' : this.state.regularSavingAmountFrequency;
        excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=performanceChartCustomSelection' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + '&fromDate=' + this.state.performanceFromDate + '&toDate=' + this.state.performanceToDate + '&initialAmount=' + this.state.initialAmount + '&regularSavings=' + regularSavingsAmount + '&regularSavingsFrequency=' + regularSavingsFrequency + '&dateOption=' + this.state.selectedDateOptionValue);
      }

      var xTicks = (0, _chart_utility.getMonthEndsBetweenDates)(getDateFromObject(plotPoints[0]), getDateFromObject(plotPoints[plotPoints.length - 1]), this.props.breakpoint > 3 ? true : false, false);
      var approxValueTip = "Approximate value of Initial Investment in the fund at NAV with dividends and capital gains reinvested, and based on the time period selected.";
      var approxPercentageTip = "Approximate percent of Initial Investment in the fund at NAV with dividends and capital gains reinvested, and based on the time period selected.";
      var IntlPerformanceChartComponent = this.injectComponent;

      var headerTitle = void 0;
      var chartLabel = "growth of hypothetical investment chart";
      var placementId = "pdpCardGrowthChart";
      if (!(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints)) {
        var shouldShowPerAdvTitle = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_PER_ADV_TITLE');
        headerTitle = shouldShowPerAdvTitle ? _string_utility2.default.renderFormattedLabel("Performance Chart", "pdp-perf-chart-header-label-adv-per") : _string_utility2.default.renderFormattedLabel("Growth of Hypothetical Investment", "pdp-perf-chart-header-label", { role: this.props.role, fundType: this.props.fundTypeCode });
        placementId = shouldShowPerAdvTitle ? "pdpCardPerformanceChart" : "pdpCardGrowthChart";
        chartLabel = shouldShowPerAdvTitle ? "performance chart" : "growth of hypothetical investment chart";
      } else {
        headerTitle = _string_utility2.default.renderFormattedLabel("Growth of Hypothetical Investment", "pdp-perf-chart-header-label", { role: this.props.role, fundType: this.props.fundTypeCode });
      }

      if (_collection_utility.CollectionUtility.includes(this.props.visibleData.visibleDataPoints, 'SHOW_PERFORMANCE_CHART_IPOP')) {
        headerTitle = _react2.default.createElement(
          'span',
          null,
          headerTitle,
          ' ',
          this.renderPopIcon("pdpCardPerformanceChartHeader")
        );
      }

      var currencyCode = !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_WITHOUT_CURRENCY_CODE') ? "" : this.props.currencyCode;
      var isRegularSavingsAndDesktop = !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART') && this.props.breakpoint > 3;
      var bottomMargin = isRegularSavingsAndDesktop ? "margin-bottom-20 tag-2" : "margin-bottom-5 tag-2";
      var title = (0, _functional_utility.isNilOrEmpty)(headerTitle) ? "Performance Chart" : _string_utility2.default.getLocalizedString(this.props.intl, headerTitle.props.defaultMessage, headerTitle.key, { role: this.props.role });
      var shouldShowGrowthofHypoHistoryButton = !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'GROWTH_OF_HYPO_HISTORY_INVESTMENT_TRUST');
      var growthOfHypoHistory = void 0;
      if (shouldShowGrowthofHypoHistoryButton) {
        var documents = (0, _ramda.pathOr)([], ["content", "documents", this.props.cusip], this.props);
        growthOfHypoHistory = documents.filter(function (doc) {
          return doc.documentType === TAG.GROWTH_OF_HYPOTHETICAL_CHART_HISTORY;
        })[0] || {};
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: "performanceChart",
          headerTitle: headerTitle,
          headerTitleId: "growthOfHypotheticalInvestmentCard",
          headerTitleLabel: "performance-chart-header",
          headerLabel: "",
          disclosureText: this.props.disclosure,
          breakpoint: this.props.breakpoint,
          placementId: placementId
        },
        _react2.default.createElement(
          'div',
          { className: 'margin-top-10 margin-bottom-30 font-regular tag' },
          _react2.default.createElement(_date_range_dropdown2.default, {
            dateRangeItems: this.dateRangeItems,
            setRef: this.setRef,
            parentProps: this.props,
            state: this.state,
            isRegularSavingsAndDesktop: isRegularSavingsAndDesktop
          }),
          this.renderCustomDateFilters(isRegularSavingsAndDesktop),
          !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_INITIAL_AMOUNT') && _react2.default.createElement(
            'div',
            {
              className: (this.props.breakpoint < 4 ? "display-inline-block width-percent-100 margin-top-40" : "display-inline-block margin-right-15 width-percent-15 text-top") + ' ' },
            _react2.default.createElement(
              'div',
              {
                className: bottomMargin, role: 'label', id: 'InitialAmount' },
              _string_utility2.default.renderFormattedLabel("INITIAL AMOUNT", "pdp-perf-chart-initial-amount-label")
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'initial-amount-test', className: 'show-error' },
              (0, _ramda.and)(error === "extreme", errorId === "amountFilter") && _react2.default.createElement(
                'span',
                { 'data-testid': 'initial-amount-close', className: 'icon-close',
                  onClick: this.updateInitialAmount },
                ' '
              ),
              (0, _ramda.and)(error === "extreme", errorId === "amountFilter") ? _react2.default.createElement('input', { type: 'text', 'data-testid': 'amount-filter',
                defaultValue: this.getFormattedInitialAmountBasedOnCategoryCode(),
                id: 'amountFilter',
                onKeyPress: this.onKeyPress,
                onBlur: this.onBlur,
                ref: this.amountFilterRef,
                'aria-labelledby': 'InitialAmount',
                className: 'padding-left-9 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + ' background-transparent height-38 border-all-1 border-radius-4 padding-right-40 border-red'
              }) : _react2.default.createElement('input', { type: 'text', 'data-testid': 'amount-filter',
                defaultValue: this.getFormattedInitialAmountBasedOnCategoryCode(),
                id: 'amountFilter',
                ref: this.amountFilterRef,
                'aria-labelledby': 'InitialAmount',
                onKeyPress: this.onKeyPress, onBlur: this.onBlur,
                className: 'display-block padding-left-9 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + ' background-transparent height-38 border-all-1 border-radius-4 padding-right-10 border-arsenic'

              })
            )
          ),
          !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART') && _react2.default.createElement(
            'div',
            {
              className: (this.props.breakpoint < 4 ? "width-percent-100 margin-top-40" : "display-inline-block margin-right-15 width-percent-15 text-top") + ' ' },
            _react2.default.createElement(
              'div',
              {
                className: 'margin-bottom-5 tag-2', role: 'label', id: 'RegularSavingsAmount' },
              _string_utility2.default.renderFormattedLabel("Regular savings amount", "pdp-perf-chart-regular-saving-amount-label")
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'regular-saving-amount-test', className: 'show-error' },
              (0, _ramda.and)(error === "extreme", errorId === "regular-saving-amountFilter") && _react2.default.createElement(
                'span',
                { 'data-testid': 'regular-saving-amount-close', className: 'icon-close',
                  onClick: this.updateRegularSavingAmount },
                ' '
              ),
              _react2.default.createElement('input', { type: 'text', 'data-testid': 'regular-saving-amount-filter',
                id: 'regular-saving-amountFilter',
                onKeyPress: this.onKeyPressRegularSavingAmount,
                onBlur: this.onRegularSavingAmtBlur,
                ref: this.regularSavingAmountFilterRef,
                'aria-labelledby': 'RegularSavingsAmount',
                className: (0, _ramda.and)(error === "extreme", errorId === "regular-saving-amountFilter") ? 'padding-left-9 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + ' background-transparent height-38 border-all-1 border-radius-4 padding-right-40 border-red' : 'display-block padding-left-9 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + ' background-transparent height-38 border-all-1 border-radius-4 padding-right-10 border-arsenic'
              })
            )
          ),
          !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART') && _react2.default.createElement(
            'div',
            {
              className: (this.props.breakpoint < 4 ? "width-percent-100 margin-top-40" : "display-inline-block margin-right-15 width-percent-15 text-top") + ' ' },
            _react2.default.createElement(
              'div',
              { className: bottomMargin, role: 'label', id: 'Frequency' },
              _string_utility2.default.renderFormattedLabel("Frequency", "pdp-perf-chart-regular-saving-amount-frequency-label")
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'regular-saving-amount-frequency-test', className: 'show-error' },
              _react2.default.createElement(
                _click_or_escape_outside2.default,
                { id: 'regular-saving-amount-frequency-selector' },
                _react2.default.createElement(_dropdown_component2.default, {
                  dropdownContent: this.getRegularSavingAmountFrequency(),
                  id: 'regularSavingAmountFrequency',
                  className: (0, _ramda.and)(error === "extreme", errorId === "regularSavingAmountFrequency") ? "width-150 margin-bottom-30 border-red" : "width-150 margin-bottom-30",
                  breakpoint: this.props.breakpoint,
                  initialActiveSelect: this.state.regularSavingAmountFrequency,
                  alwaysOpenOnSelect: false,
                  onOpenDropdownCallback: function onOpenDropdownCallback() {
                    return _this10.removeRegularSavingsFrequencyError();
                  },
                  initialActiveSelectTranslationKey: this.state.regularSavingAmountFrequencyTranslatedKey,
                  ariaLabelledby: 'Frequency'

                })
              )
            )
          ),
          !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_APPROX_VALUE') && _react2.default.createElement(
            'div',
            {
              className: (this.props.breakpoint < 4 ? "margin-top-20 width-percent-50" : "margin-right-15 width-percent-15") + ' display-inline-block text-top tag-2' },
            _string_utility2.default.renderFormattedLabel("APPROX VALUE ", "pdp-perf-chart-approx-value-label", { role: this.props.role }),
            _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, "SHOW_INFORMATION_POPUP") ? this.renderIcon(approxValueTip, 'approx-value', _string_utility2.default.getLocalizedString(this.props.intl, "APPROX VALUE", "pdp-perf-chart-approx-value-label")) : "",
            _react2.default.createElement(
              'div',
              { className: 'font-super-black ' + (this.props.breakpoint < 4 ? 'padding-top-5 body-bold' : 'padding-top-0 sub-header-2'),
                'data-testid': 'approx-value' },
              this.getFormattedValue(approxValue)
            )
          ),
          !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'PERFORMANCE_CHART_APPROX_PERCENTAGE') && _react2.default.createElement(
            'div',
            {
              className: (this.props.breakpoint < 4 ? "margin-top-20 width-percent-50" : "margin-right-15 width-percent-8") + ' display-inline-block text-top tag-2' },
            _string_utility2.default.renderFormattedLabel("APPROX % ", "pdp-perf-chart-approx-percent-label"),
            _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, "SHOW_INFORMATION_POPUP") ? this.renderIcon(approxPercentageTip, 'approx-percentage', _string_utility2.default.getLocalizedString(this.props.intl, "APPROX %", "pdp-perf-chart-approx-percent-label")) : "",
            _react2.default.createElement(
              'div',
              { className: 'font-super-black ' + (this.props.breakpoint < 4 ? 'padding-top-5 body-bold' : 'padding-top-0 sub-header-2'),
                'data-testid': 'approx-percentage' },
              approxPercentage + '%'
            )
          )
        ),
        _react2.default.createElement(IntlPerformanceChartComponent, {
          plotPoints: plotPoints,
          yTicks: yTicks,
          xTicks: xTicks,
          fundCurrencyCode: this.props.fundCurrencyCode,
          breakpoint: this.props.breakpoint,
          dateOption: this.state.selectedDateOptionValue,
          initialAmount: this.state.initialAmount,
          currencyCode: currencyCode,
          numberFormat: this.props.numberFormat,
          visibleDataPoints: (this.props.visibleData || {}).visibleDataPoints,
          formattingRules: (this.props.visibleData || {}).formattingRules,
          benchmarkRestructuringDate: this.props.benchmarkRestructuringDate,
          fundTypeCode: this.props.fundTypeCode,
          country: this.props.country,
          role: this.props.role,
          chartName: chartLabel
        }),
        this.renderPerformanceChartLegend(plotPoints),
        !(0, _ramda.isNil)((this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'HIDE_DOWNLOAD_BUTTON') ? _react2.default.createElement('noscript', null) : _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-data",
          downloadURL: excelServiceURL,
          dataTestLink: "performanceChart-excel-download-link",
          text: _string_utility2.default.renderFormattedLabel('DOWNLOAD CHART DATA', 'pdp-download-chart-data', { role: this.props.role }),
          additionalClassName: "mobile-full-width",
          callBack: this.trackChartDownload,
          ariaLabel: 'Download Chart Data for ' + title
        }),
        shouldShowGrowthofHypoHistoryButton && growthOfHypoHistory.docURL && _react2.default.createElement(_button2.default, {
          dataTest: "growth-of-hypo-history",
          downloadURL: growthOfHypoHistory.docURL,
          dataTestLink: "growth-of-hypo-chart-history",
          text: _string_utility2.default.renderFormattedLabel('DOWNLOAD HISTORY', 'pdp-download-growth-of-hypo-history', { role: this.props.role }),
          additionalClassName: (this.props.breakpoint >= 3 ? "margin-left-20" : "") + ' mobile-full-width',
          ariaLabel: 'DOWNLOAD HISTORY'
        }),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'performance-chart-parent-print-disclosure',
            className: 'text-justified font-light caption print-display', style: { "display": "none" } },
          _react2.default.createElement(
            'div',
            { 'data-testid': 'approx-value-print', className: 'margin-bottom-15 text-justified' },
            approxValueTip
          ),
          _react2.default.createElement(
            'div',
            { 'data-testid': 'approx-percent-print',
              className: 'margin-bottom-15 text-justified' },
            approxPercentageTip
          )
        )
      );
    }
  }], [{
    key: 'calculatePercentageIncrease',
    value: function calculatePercentageIncrease(maxAmount, initialAmount) {
      return (maxAmount - initialAmount) / initialAmount * 100;
    }
  }]);

  return PerformanceChartParent;
}(_react2.default.Component);

exports.default = PerformanceChartParent;